<script>
  import { scaleLinear } from "d3-scale";
  import { interpolateHcl } from "d3-interpolate";

  import Number from "./Number.svelte";
  import regionMeans from "./../data/means.json";
  import { map_legend_title, map_legend_subhead } from "./../content/data.json";

  // export let activeYearIndex = 0;

  const values = Object.values(regionMeans);

  const maxValue = Math.max(
    Math.abs(Math.min(...values)),
    Math.abs(Math.max(...values))
  );
  const roundedMaxValue = Math.round(maxValue / 100) * 100;

  $: colorScale = scaleLinear([
    "#269abe",
    "#1f8b8f",
    "#444",
    "#fa6138",
    "#ff0047"
  ])
    .domain([-maxValue, -maxValue / 2, 0, maxValue / 2, maxValue])
    .interpolate(interpolateHcl)
    .clamp(true);

  $: ticks = [-roundedMaxValue, ...colorScale.ticks(20), roundedMaxValue].map(
    d => [d, colorScale(d)]
  );
</script>

<div class="c">
  <div class="title">{map_legend_title}</div>
  <div class="subheading">{map_legend_subhead}</div>
  <div
    class="gradient"
    style="{`background: linear-gradient(to right, ${ticks
      .map(([v, color]) => color)
      .join(', ')})`}">
    <div class="dots">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
  <div class="values">
    <div class="value">
      <Number number="{-roundedMaxValue}" format=",.0f" />
    </div>
    <div class="value">0</div>
    <div class="value">
      +
      <Number number="{roundedMaxValue}" format=",.0f" />
    </div>
  </div>
  <!-- {#each ticks as tick}{tick}{/each} -->
</div>

<style>
  .c {
    margin: 1em 0;
  }
  .title {
    font-size: 0.8rem;
    line-height: 1.3em;
    margin-bottom: 0;
  }
  .subheading {
    margin: 0.2em 0 1em;
    font-size: 0.7rem;
    line-height: 1.3em;
    opacity: 0.6;
  }
  .gradient {
    position: relative;
    height: 0.6em;
    margin: 0.3em 0;
    width: 100%;
    border-radius: 29px;
  }
  .dots {
    position: absolute;
    top: 50%;
    left: 0.2em;
    right: 0.27em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transform: translate(0, -50%);
  }
  .dot {
    width: 0.2em;
    height: 0.2em;
    background: white;
    border-radius: 100%;
  }
  .values {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .value {
    font-size: 0.7em;
    line-height: 1.1em;
    width: 0;
    white-space: nowrap;
  }
  .value:nth-of-type(2) {
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .value:last-of-type {
    text-align: right;
    display: flex;
    justify-content: flex-end;
  }
</style>
